export default __webpack_public_path__ + "static/media/abdulsalam.c38d900f.png";